module.exports = __webpack_public_path__ + "static/media/build10.3397645e.jpg";